import _ from 'lodash';

const identifyCartChanges = (
  requestedCart,
  newCart,
  products,
  cartChanges,
  combos
) => {
  let unavailableProducts = [];

  const newCartProducts = newCart.reduce((acc, item) => {
    const configProducts = item.config_products.map(product => ({
      quantity: product.quantity,
      product_id: product.product_id,
      configuration: product.configuration,
    }));
    return [...acc, ...configProducts];
  }, []);

  requestedCart.forEach(item => {
    if (
      !newCartProducts.find(newItem =>
        _.isEqual(item.config_products[0], newItem)
      )
    ) {
      const product =
        products &&
        products.length &&
        products.find(
          product => product.product_id === item.config_products[0].product_id
        );

      const combo = combos && combos.find(combo => combo.id === item.combo_id);
      if (product) {
        unavailableProducts = [
          ...unavailableProducts,
          {name: product.name, product_id: product.product_id},
        ];
      }
      if (combo) {
        unavailableProducts = [
          ...unavailableProducts,
          {name: combo.name, product_id: combo.id, isCombo: true},
        ];
      }
    }
  });
  unavailableProducts = unavailableProducts.filter((product, index, self) => {
    return (
      index ===
      self.findIndex(product2 => {
        return product2.product_id === product.product_id;
      })
    );
  });
  return unavailableProducts;
};

export default identifyCartChanges;
